<ul class="banner-list">
    <!--<li><img src="../../../../../assets/kitdigital/Logo PRTR dos li╠üneas_COLOR.jpg" alt="Plan de recuperación, transofmración y resiliencia" /></li>
    <li><img src="../../../../../assets/kitdigital/04.png" alt="Finaciado por la unión europea" /></li>-->
</ul>
